import { useState, useEffect } from 'react';
import dashboardService from '../services/dashboardService';
function useDashboards(id) {
    const [dashboard, setDashboard] = useState(null);
    const { getDashboard } = dashboardService;
    async function setUpDashboard() {
        const [response, errors] = await getDashboard({ id: id })
        if (errors != null) {
            console.log(errors)
            return;
        }
        let blocks = response.blocks.sort(function (a, b) {
            return (a.position === null) - (b.position === null) || +(a.position > b.position) || -(a.position < b.position);
        });
        response.blocks = blocks;
        setDashboard(response);
    }
    
    useEffect(() => {
        setUpDashboard();
    },[]);

    return {dashboard,setUpDashboard};
}

export default useDashboards;